import React from "react";
import { v4 as uuidv4 } from "uuid";
import HF from "../../assets/images/hflogo.png";
import CNRS from "../../assets/images/service/cnrs.png";
import MunicipalityBqosta from "../../assets/images/service/municipality-of-bqosta.png";
import MunicipalitySaida from "../../assets/images/service/Saida-Municiplaity.png";
import MOE from "../../assets/images/service/moe.png";
import UNEP from "../../assets/images/service/unep.png";
import SNS from "../../assets/images/service/sns.png";
import ANAMILOUNA from "../../assets/images/Anamilouna.png";
import PLASTCLAB from "../../assets/images/service/plastclab.png";
import RHHS from "../../assets/images/schools/RHHS.png";
import HBHS from "../../assets/images/schools/HBHS.jpg";
import HHHS from "../../assets/images/schools/HHHS.jpg";
import HSS from "../../assets/images/schools/Hekmat Sabagh School.jpg";
import OFOQ from "../../assets/images/schools/Al Ofoq Al Jadeed School.jpg";
import QULAA from "../../assets/images/schools/Al Qualaa.jpg";
import SAA from "../../assets/images/schools/Secondary Official School Of The Educate Souraya Fares Abou Alfa.jpg";
import OMANIYA from "../../assets/images/schools/Omaniya Modern School.png";
import MZHS from "../../assets/images/schools/ZHS.jpg";
import ASPS from "../../assets/images/schools/ASPS.jpg";
import SIPS from "../../assets/images/schools/Saida Intermediate Public School.jpg";
import SEPS from "../../assets/images/schools/Saida Elementary Public School.jpg";
import NBHS from "../../assets/images/schools/NBHS 1.jpg";
import LKS from "../../assets/images/schools/Saida Public Lebanese Kuwaity School 1.jpg";
import NEIGB from "../../assets/images/schools/National Evangelical Institute.jpg";
import SHS from "../../assets/images/schools/Safir High School.png";
import LOJ from "../../assets/images/schools/Lycee Officiel Jezzine.jpg";
import MOWASAT from "../../assets/images/schools/Mowasat.jpg";

const MotherOrganizationData = [
  {
    id: uuidv4(),
    heading: "Hariri Foundation  ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: HF,
    style: { width: "120px", height: "120px", objectFit: "contain" },
  },
];

const InternationalOrganizationsData = [
  {
    id: uuidv4(),
    heading: "UNEP ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: UNEP,
    style: { width: "120px", height: "120px", objectFit: "contain" },
  },
];

const PublicSectorData = [
  {
    id: uuidv4(),
    heading: "Ministry of Environment ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: MOE,
    style: { width: "120px", height: "120px", objectFit: "contain" },
  },
  {
    id: uuidv4(),
    heading: "CNRS  ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: CNRS,
    style: { width: "120px", height: "120px", objectFit: "contain" },
  },
  {
    id: uuidv4(),
    heading: "Municipality of Saida  ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: MunicipalitySaida,
    style: { width: "120px", height: "120px", objectFit: "contain" },
  },
  {
    id: uuidv4(),
    heading: "Municipality  of Bqosta ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: MunicipalityBqosta,
    style: { width: "120px", height: "120px", objectFit: "contain" },
  },
];

const PrivateCivicSectorData = [
  {
    id: uuidv4(),
    heading: "SNS  ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: SNS,
    style: { width: "320px", height: "320px", objectFit: "contain" },
  },
  {
    id: uuidv4(),
    heading: "Plastc Lab  ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: PLASTCLAB,
    style: { width: "120px", height: "120px", objectFit: "contain" },
  },
  {
    id: uuidv4(),
    heading: "Anamilouna  ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: ANAMILOUNA,
    style: { width: "120px", height: "120px", objectFit: "contain" },
  },
];

const SchoolsData = [
  {
    id: uuidv4(),
    heading: "Rafic Hariri High School  ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: RHHS,
  },
  {
    id: uuidv4(),
    heading: "Hajj Bahaaddine Hariri High School ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: HBHS,
  },
  {
    id: uuidv4(),
    heading: "Houssam Hariri High School  ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: HHHS,
  },
  {
    id: uuidv4(),
    heading: "Hekmat Sabagh School ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: HSS,
  },
  {
    id: uuidv4(),
    heading: "Al Ofoq Al Jadeed School ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: OFOQ,
  },
  {
    id: uuidv4(),
    heading: "Al Qualaa Secondary School",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: QULAA,
  },
  {
    id: uuidv4(),
    heading: "Soraya Abou Alfa School",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: SAA,
  },
  {
    id: uuidv4(),
    heading: "Omaniya Modern School  ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: OMANIYA,
  },
  {
    id: uuidv4(),
    heading: "Mostafa Zaaatari High School  ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: MZHS,
  },
  {
    id: uuidv4(),
    heading: "ASPS  ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: ASPS,
  },
  {
    id: uuidv4(),
    heading: "Saida Intermediate Public School  ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: SIPS,
  },
  {
    id: uuidv4(),
    heading: "Saida Elementary Public School  ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: SEPS,
  },
  {
    id: uuidv4(),
    heading: "Nazih Bizri High School  ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: NBHS,
  },
  {
    id: uuidv4(),
    heading: "Lebanese Kuwaity School  ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: LKS,
  },
  {
    id: uuidv4(),
    heading: "National Evangelical Institute for Girls & Boys  ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: NEIGB,
  },
  {
    id: uuidv4(),
    heading: "Safir High School  ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: SHS,
  },
  {
    id: uuidv4(),
    heading: "Lycee Officiel Jezzine  ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: LOJ,
  },
  {
    id: uuidv4(),
    heading: "Saida Technical Institue for Girls (Al Mowasat)  ",
    description:
      "There are many variations of passages the majority have suffered alteration form",
    img: MOWASAT,
  },
];

const MotherOrganization = ({ img, heading, description, serviceLink }) => {
  return (
    <>
      <div className="col-xl-4 col-lg-4 col-md-6">
        <div className="single-service2 text-center">
          <div className="service-icon ml-5">
            <div className="image-box-hf">
              <img
                src={img}
                alt="Service Icon"
                style={{ width: "55%", height: "auto" }}
              />
            </div>
          </div>
          <h3 style={{ paddingTop: "30px" }}>{heading}</h3>
        </div>
      </div>
    </>
  );
};
const InternationalOrganizations = ({
  img,
  heading,
  description,
  serviceLink,
}) => {
  return (
    <>
      <div className="col-xl-4 col-lg-4 col-md-6">
        <div className="single-service2 text-center">
          <div className="service-icon ml-5">
            <div className="image-box">
              <img
                src={img}
                alt="Service Icon"
                style={{ width: "100%", height: "auto" }}
              />
            </div>
          </div>
          <h3 style={{ paddingTop: "30px" }}>{heading}</h3>
        </div>
      </div>
    </>
  );
};
const PublicSector = ({ img, heading, description, serviceLink }) => {
  return (
    <>
      <div className="col-xl-4 col-lg-4 col-md-6">
        <div className="single-service2 text-center">
          <div className="service-icon ml-5">
            <div className="image-box">
              <img
                src={img}
                alt="Service Icon"
                style={{ width: "100%", height: "auto" }}
              />
            </div>
          </div>
          <h3 style={{ paddingTop: "30px" }}>{heading}</h3>
        </div>
      </div>
    </>
  );
};
const PrivateCivicSector = ({ img, heading, description, serviceLink }) => {
  return (
    <>
      <div className="col-xl-4 col-lg-4 col-md-6">
        <div className="single-service2 text-center">
          <div className="service-icon ml-5">
            <div className="image-box">
              <img
                src={img}
                alt="Service Icon"
                style={{ width: "100%", height: "auto" }}
              />
            </div>
          </div>
          <h3 style={{ paddingTop: "30px" }}>{heading}</h3>
        </div>
      </div>
    </>
  );
};
const Schools = ({ img, heading }) => {
  return (
    <>
      <div className="col-xl-4 col-lg-4 col-md-6">
        <div className="single-service2 text-center">
          <div className="service-icon ml-5">
            <div className="image-box">
              <img
                src={img}
                alt="School"
                style={{ width: "55%", height: "auto" }}
              />
            </div>
          </div>
          <h3 style={{ paddingTop: "30px" }}>{heading}</h3>
        </div>
      </div>
    </>
  );
};

const ServiceStyleTwo = () => {
  return (
    <>
      <div
        className="service-area"
        style={{
          backgroundColor: "#ffffff",
          paddingTop: "30px",
          paddingBottom: "30px",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "30px" }}>
          Mother Organization
        </h2>
        <div className="container">
          <div className="row">
            {MotherOrganizationData.map((data) => (
              <MotherOrganization
                key={data.id}
                img={data.img}
                heading={data.heading}
                description={data.description}
                serviceLink={data.serviceLink}
              />
            ))}
          </div>
        </div>
      </div>
      <div
        className="service-area"
        style={{
          backgroundColor: "#ffffff",
          paddingTop: "30px",
          paddingBottom: "30px",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "30px" }}>
          International Organizations
        </h2>
        <div className="container">
          <div className="row">
            {InternationalOrganizationsData.map((data) => (
              <InternationalOrganizations
                key={data.id}
                img={data.img}
                heading={data.heading}
                description={data.description}
                serviceLink={data.serviceLink}
              />
            ))}
          </div>
        </div>
      </div>
      <div
        className="service-area"
        style={{
          backgroundColor: "#ffffff",
          paddingTop: "30px",
          paddingBottom: "30px",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "30px" }}>
          Public Sector
        </h2>
        <div className="container">
          <div className="row">
            {PublicSectorData.map((data) => (
              <PublicSector
                key={data.id}
                img={data.img}
                heading={data.heading}
                description={data.description}
                serviceLink={data.serviceLink}
              />
            ))}
          </div>
        </div>
      </div>
      <div
        className="service-area"
        style={{
          backgroundColor: "#ffffff",
          paddingTop: "30px",
          paddingBottom: "30px",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "30px" }}>
          Private & Civic Sector
        </h2>
        <div className="container">
          <div className="row">
            {PrivateCivicSectorData.map((data) => (
              <PrivateCivicSector
                key={data.id}
                img={data.img}
                heading={data.heading}
                description={data.description}
                serviceLink={data.serviceLink}
              />
            ))}
          </div>
        </div>
      </div>
      <div
        className="service-area"
        style={{
          backgroundColor: "#ffffff",
          paddingTop: "30px",
          paddingBottom: "30px",
        }}
      >
        <h2 style={{ textAlign: "center", marginBottom: "30px" }}>Schools</h2>
        <div className="container">
          <div className="row">
            {SchoolsData.map((data) => (
              <Schools
                key={data.id}
                img={data.img}
                heading={data.heading}
                description={data.description}
                serviceLink={data.serviceLink}
              />
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ServiceStyleTwo;
